// extracted by mini-css-extract-plugin
export default {"inquiryBox":"ProductInquiry_inquiryBox__Fq6VL","text":"ProductInquiry_text__-ZJUV","btnBox":"ProductInquiry_btnBox__CA2HS","addBtn":"ProductInquiry_addBtn__ZYUcd"};